import __vue_component__ from '../Spinner/Spinner.vue.js';

//
var script = {
  name: 'Button',
  components: {
    Spinner: __vue_component__
  },
  props: {
    isSelected: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    appearance: {
      type: String,
      default: 'default'
    },
    autoFocus: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    spacing: {
      type: String,
      default: 'default'
    }
  },
  computed: {
    iconIsOnlyChild() {
      return !!(this.$slots['icon-after'] && !this.$slots['icon-before'] && !this.$slots.default) || !this.$slots['icon-after'] && this.$slots['icon-before'] && !this.$slots.default;
    },

    listeners() {
      return this.$listeners;
    }

  },

  mounted() {
    if (this.autoFocus) {
      this.$refs.button.focus();
    }
  }

};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Button/Button.vue_rollup-plugin-vue=script.js